<template>
  <svg id="icon-copy" width="20" height="20" viewBox="0 0 20 20">
    <g fill="none" fill-rule="evenodd">
      <path stroke="currentColor" d="M-435.5-12.5h554v512h-554z" />
      <g
        transform="translate(5 5)"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <rect x="2.444" y="2.444" width="7.944" height="7.944" rx="1" />
        <path d="M1.833 7.944h-.61A1.222 1.222 0 0 1 0 6.722v-5.5C0 .547.547 0 1.222 0h5.5c.675 0 1.222.547 1.222 1.222v.611" />
      </g>
    </g>
  </svg>
</template>
